var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getDateByFormat, removeHashRevokeUserEmail, } from '@/shared/utils/helpers';
import { Component, Vue, Watch } from 'vue-property-decorator';
import Pagination from 'components/Pagination.vue';
import { getCreditConsumptionsGroupedByUser } from '@/clients/admin';
let CreditsHistoryDetails = class CreditsHistoryDetails extends Vue {
    constructor() {
        super(...arguments);
        this.page = 1;
        this.totalPages = 0;
        this.consumptions = [];
        this.loading = true;
    }
    async mounted() {
        this.fetchConsumptions();
    }
    async fetchConsumptions() {
        this.loading = true;
        try {
            const response = await getCreditConsumptionsGroupedByUser({
                accountId: this.accountSelected,
                page: this.page,
                initDate: this.formattedPeriod[0],
                endDate: this.formattedPeriod[1],
                groupByFormat: this.consumptionDetail.group_by,
                type: this.consumptionDetail.type,
            });
            this.consumptions = response.data.flatMap(payload => payload.data.map(data => data));
            const metadata = response.data[0].metadata;
            if (metadata.length) {
                this.totalPages = Math.ceil(metadata[0].total / 10);
            }
        }
        catch (e) {
            console.log(e);
        }
        this.loading = false;
    }
    setPageNumber(page) {
        this.page = page;
        this.fetchConsumptions();
    }
    showEmail(email) {
        return removeHashRevokeUserEmail(email);
    }
    changedDetail() {
        this.fetchConsumptions();
    }
    get accountSelected() {
        return this.$store.getters['admin/get_selected_account'];
    }
    get consumptionDetail() {
        return this.$store.getters['admin/get_credit_consumption_detail'];
    }
    get formattedPeriod() {
        const { group_by, period } = this.consumptionDetail;
        if (group_by === '%Y-%m-%d') {
            const [year, month, day] = period.split('-').map(Number);
            const initDate = new Date(year, month - 1, day, 0, 0, 0, 0).toISOString();
            const endDate = new Date(year, month - 1, day, 23, 59, 59, 999).toISOString();
            return [initDate, endDate];
        }
        if (group_by === '%Y-%m') {
            const [year, month] = period.split('-').map(Number);
            const initDate = new Date(year, month - 1, 1).toISOString();
            const endDate = new Date(year, month, 0).toISOString();
            return [initDate, endDate];
        }
        if (group_by === '%Y') {
            const year = parseInt(period, 10);
            const initDate = new Date(year, 0, 1).toISOString(); // 1º de janeiro
            const endDate = new Date(year, 11, 31).toISOString(); // 31 de dezembro
            return [initDate, endDate];
        }
        return [];
    }
    get periodLabel() {
        const { group_by, period } = this.consumptionDetail;
        if (group_by === '%Y')
            return period;
        if (group_by === '%Y-%m')
            return getDateByFormat(period, 'MMMM/YYYY');
        if (group_by === '%Y-%m-%d')
            return getDateByFormat(period, 'dddd, D [de] MMMM/YYYY');
        return '';
    }
    get typeLabel() {
        switch (this.consumptionDetail.type) {
            case 'unlimited_click':
                return 'Cliques ilimitados';
            case 'click':
                return 'Cliques';
            case 'export':
                return 'Exportações';
            default:
                return '';
        }
    }
};
__decorate([
    Watch('consumptionDetail')
], CreditsHistoryDetails.prototype, "changedDetail", null);
CreditsHistoryDetails = __decorate([
    Component({
        components: {
            Pagination,
        },
    })
], CreditsHistoryDetails);
export default CreditsHistoryDetails;
